import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_MARRAKECH_ERG } from "@/lib/itineraryHubs";
export default function MarrakechErgChebbiHubPage() {
  return <ItineraryHubPage hub={HUB_MARRAKECH_ERG} />;
}
